import React, { createContext, useState } from "react";

//Crear el context
export const MarcasContext = createContext();

//provider es donde se encuentran las funciones y state
const MarcasProvider = (props) => {
  const [marcas, setMarcas] = useState("jeep");

  return (
    <MarcasContext.Provider
      value={{
        marcas,
        setMarcas,
      }}
    >
      {props.children}
    </MarcasContext.Provider>
  );
};

export default MarcasProvider;
